import { useParams } from "react-router-dom";
import { GuideTabs } from "../components/GuideTabs";
import { Icon } from "../components/icons";
import { ReRecordingGuide } from "../components/ReRecordingGuide";

/**
 * The public Re-recording guide (`/share/:token/guide`) — same token and same
 * no-login access as the Pickups Package, available once the owner has turned
 * the guide on for the link. Anyone with the link can play passages and tick
 * them re-recorded; their browser remembers the name they tick under.
 */
export function SharedGuide() {
  const { token } = useParams();
  return (
    <div className="pickups-standalone rrg-page">
      <header className="pk-topbar">
        <a className="pk-brand" href="/" target="_blank" rel="noopener noreferrer" title="About Mockingbird">
          <Icon name="logo" size={22} />
          <span className="pk-brand-name">Mockingbird</span>
        </a>
        <GuideTabs active="guide" pickupsTo={`/share/${token}`} guideTo={`/share/${token}/guide`} />
      </header>
      <div className="page rrg-wrap">
        <ReRecordingGuide source={{ base: `/api/share/${token}`, queryKey: ["share-guide", token], anonymous: true }} />
      </div>
    </div>
  );
}
